import { Box, Paper, Typography } from "@mui/material";
import FacilityHelmet from "../../../../../Helmets/FacilityHelmet";
import FacilityImageCarousel from "./FacilityImageCarousel";

export default function FacilityPage() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        m: 1,
      }}
    >
      <FacilityHelmet />
      <Paper sx={{ width: "200px" }}>
        <Typography>Ο χώρος μας!</Typography>
      </Paper>

      <Paper sx={{ m: 1 }}>
        <FacilityImageCarousel />
      </Paper>
    </Box>
  );
}
